import { CircularProgress } from 'components'
import React, { useMemo, useState } from 'react'

import { tx } from '@twind/core'

// import { TrophyIcon } from '../assets'
import { User } from '../user.types'

const DevsnestData = ({ user }: { user: User }) => {
  // const { data: dashboardDetails, isLoading: isDashboardDetailsLoading } =
  //   useFetchDashboardDetails()

  const dashboardDetails = {
    fe_rank: user.fe_rank,
    dsa_rank: user.dsa_rank,
    be_rank: null
  }

  return (
    <div className="flex w-full flex-col bg-[#1A1A1E] p-6 gap-4 rounded-sm">
      <div className="flex flex-col lg:flex-row w-full gap-4 my-2">
        {/* 55% and 45 if all three cards */}
        <div className="flex lg:w-[75%]">
          <SolvedQuestion user={user} />
        </div>

        <div className="flex gap-4 lg:w-[25%]">
          {/* 65 and 35 if all three card */}
          <div className="flex w-[100%]">
            <LeaderboardData dashboardDetails={dashboardDetails} />
          </div>
          {/* <div className="flex w-[35%]">
            {!isDashboardDetailsLoading && dashboardDetails ? (
              <BestRank dashboardDetails={dashboardDetails} />
            ) : (
              <Loading />
            )}
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default DevsnestData

const CardWrapper = ({
  children,
  classname
}: {
  children: React.ReactNode
  classname?: string
}) => {
  return (
    <div
      className={tx(
        'flex h-full w-full p-px rounded-md bg-gradient-to-br from-indigo-400 via-red-700 to-yellow-700',
        classname && classname
      )}>
      <div className="flex h-full w-full bg-zinc-800 rounded-md">
        {children}
      </div>
    </div>
  )
}

const SolvedQuestion = ({ user }: { user: User }) => {
  const [currentTab, setCurrentTab] = useState('fe_solved')
  const {
    easy_level: easy = 0,
    medium_level: medium = 0,
    hard_level: hard = 0
  } = user.solved
  const { html = 0, css = 0, javascript = 0, react = 0 } = user.fe_solved

  const {
    easy_level: easy_t = 0,
    medium_level: medium_t = 0,
    hard_level: hard_t = 0
  } = user.total_by_difficulty

  const {
    html: html_t = 0,
    css: css_t = 0,
    javascript: javascript_t = 0,
    react: react_t = 0
  } = user.fe_total_by_topic

  const tabData = useMemo(() => {
    if (currentTab === 'dsa_solved') {
      return { total: easy_t + medium_t + hard_t, done: easy + medium + hard }
    }

    if (currentTab === 'fe_solved') {
      return {
        total: html_t + css_t + javascript_t + react_t,
        done: html + css + javascript + react
      }
    }

    return { total: 1, done: 0 }
  }, [
    currentTab,
    easy_t,
    medium_t,
    hard_t,
    easy,
    medium,
    hard,
    html_t,
    css_t,
    javascript_t,
    react_t,
    html,
    css,
    javascript,
    react
  ])

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex justify-between">
        <div className="text-lg font-semibold mb-2">Solved Questions</div>
        <div className="flex gap-x-2 justify-between mt-1 pr-4">
          {[
            { key: 'dsa_solved', label: 'DSA' },
            { key: 'fe_solved', label: 'Frontend' }
            // { key: 'be_solved', label: 'BE Solved' }
          ].map((val) => (
            <div
              key={val.key}
              onClick={() => {
                if (val.key !== 'be_solved') setCurrentTab(val.key)
              }}
              className={tx(
                'text-base mr-2',
                val.key === currentTab ? 'text-primary' : 'text-[#71717A]',
                val.key === 'be_solved'
                  ? 'cursor-not-allowed'
                  : 'cursor-pointer'
              )}>
              {val.label}
            </div>
          ))}
        </div>
      </div>

      <CardWrapper>
        <div className="flex items-center gap-4 p-3 h-full w-full">
          <div className="relative">
            <CircularProgress
              progress={tabData?.done / tabData?.total}
              fillColor="text-[#5A5AB4]"
              inactiveColor="text-zinc-500"
              className="h-32 w-32"
              radiusWidth={90}
            />

            <div className="flex flex-col gap-2 items-center justify-center absolute top-[28%] left-[34%]">
              <div className="text-lg font-semibold">{tabData.done}</div>
              <div className="text-sm text-[#C1C1C1]">Solved</div>
            </div>
          </div>

          <div className="flex flex-1 flex-col gap-2">
            {/* for DSA Solved */}
            {currentTab === 'dsa_solved' && (
              <>
                {/* Easy */}
                <div className="flex flex-col gap-1 text-[#C1C1C1] text-base">
                  <div className="flex justify-between">
                    <div>Easy</div>
                    <div>
                      <span className="text-white text-lg">{easy}</span>/
                      {easy_t}
                    </div>
                  </div>

                  <div
                    className="flex w-full rounded-md"
                    style={{ background: 'rgba(74, 222, 128, 0.3)' }}>
                    <div
                      className={tx(
                        'p-1 rounded-l-md rounded-r-sm',
                        (easy / easy_t) * 100 > 0 && 'bg-green-500'
                      )}
                      style={{ width: `${(easy / easy_t) * 100}%` }}></div>
                  </div>
                </div>

                {/* Medium */}
                <div className="flex flex-col gap-1 text-[#C1C1C1] text-base">
                  <div className="flex justify-between">
                    <div>Medium</div>
                    <div>
                      <span className="text-white text-lg">{medium}</span>/
                      {medium_t}
                    </div>
                  </div>

                  <div
                    className="flex w-full rounded-md"
                    style={{ background: 'rgba(250, 204, 21, 0.3)' }}>
                    <div
                      className={tx(
                        'p-1 rounded-l-md rounded-r-sm',
                        (medium / medium_t) * 100 > 0 && 'bg-yellow-500'
                      )}
                      style={{
                        width: `${(medium / medium_t) * 100}${
                          (medium / medium_t) * 100 > 0 ? '%' : ''
                        }`
                      }}></div>
                  </div>
                </div>

                {/* Hard */}
                <div className="flex flex-col gap-1 text-[#C1C1C1] text-base">
                  <div className="flex justify-between">
                    <div>Hard</div>
                    <div>
                      <span className="text-white text-lg">{hard}</span>/
                      {hard_t}
                    </div>
                  </div>

                  <div
                    className="flex w-full rounded-md"
                    style={{ background: 'rgba(239, 68, 68, 0.3)' }}>
                    <div
                      className={tx(
                        'p-1 rounded-l-md rounded-r-sm',
                        (hard / hard_t) * 100 > 0 && 'bg-red-500'
                      )}
                      style={{ width: `${(hard / hard_t) * 100}%` }}></div>
                  </div>
                </div>
              </>
            )}

            {/* for FE Solved */}
            {currentTab === 'fe_solved' && (
              <>
                {/* Html */}
                <div className="flex flex-col gap-1 text-[#C1C1C1] text-base">
                  <div className="flex justify-between">
                    <div>HTMl</div>
                    <div>
                      <span className="text-white text-lg">{html}</span>/
                      {html_t}
                    </div>
                  </div>

                  <div
                    className="flex w-full rounded-md"
                    style={{ background: 'rgba(74, 222, 128, 0.3)' }}>
                    <div
                      className={tx(
                        'p-1 rounded-l-md rounded-r-sm',
                        (html / html_t) * 100 > 0 && 'bg-green-500'
                      )}
                      style={{ width: `${(html / html_t) * 100}%` }}></div>
                  </div>
                </div>

                {/* CSS */}
                <div className="flex flex-col gap-1 text-[#C1C1C1] text-base">
                  <div className="flex justify-between">
                    <div>CSS</div>
                    <div>
                      <span className="text-white text-lg">{css}</span>/{css_t}
                    </div>
                  </div>

                  <div
                    className="flex w-full rounded-md"
                    style={{ background: 'rgba(250, 204, 21, 0.3)' }}>
                    <div
                      className={tx(
                        'p-1 rounded-l-md rounded-r-sm',
                        (css / css_t) * 100 > 0 && 'bg-yellow-500'
                      )}
                      style={{ width: `${(css / css_t) * 100}%` }}></div>
                  </div>
                </div>

                {/* Javascript */}
                <div className="flex flex-col gap-1 text-[#C1C1C1] text-base">
                  <div className="flex justify-between">
                    <div>Javascript</div>
                    <div>
                      <span className="text-white text-lg">{javascript}</span>/
                      {javascript_t}
                    </div>
                  </div>

                  <div
                    className="flex w-full rounded-md"
                    style={{ background: 'rgba(239, 68, 68, 0.3)' }}>
                    <div
                      className={tx(
                        'p-1 rounded-l-md rounded-r-sm',
                        (javascript / javascript_t) * 100 > 0 && 'bg-red-500'
                      )}
                      style={{
                        width: `${(javascript / javascript_t) * 100}%`
                      }}></div>
                  </div>
                </div>

                {/* React */}
                <div className="flex flex-col gap-1 text-[#C1C1C1] text-base">
                  <div className="flex justify-between">
                    <div>React</div>
                    <div>
                      <span className="text-white text-lg">{react}</span>/
                      {react_t}
                    </div>
                  </div>

                  <div
                    className="flex w-full rounded-md"
                    style={{ background: 'rgba(96, 165, 250, 0.3)' }}>
                    <div
                      className={tx(
                        'p-1 rounded-l-md rounded-r-sm',
                        (react / react_t) * 100 > 0 && 'bg-blue-500'
                      )}
                      style={{ width: `${(react / react_t) * 100}%` }}></div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </CardWrapper>
    </div>
  )
}

const LeaderboardData = ({
  dashboardDetails
}: {
  dashboardDetails: {
    fe_rank: User['fe_rank']
    be_rank?: null
    dsa_rank: User['dsa_rank']
  }
}) => {
  const { dsa_rank, fe_rank } = dashboardDetails

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex justify-between">
        <div className="text-lg font-semibold mb-2">Leaderboard</div>
      </div>
      <CardWrapper classname="">
        <div className="flex flex-col h-full w-full">
          <div className="text-base p-6 border-b-1 border-zinc-700">
            Current Rankings
          </div>

          <table className="w-full">
            <tr className="border-b-1 border-zinc-700">
              <td className="text-[#C1C1C1] p-3">DSA:</td>
              <td className="font-medium p-3">
                {dsa_rank ? dsa_rank.rank : '-'}
              </td>
            </tr>
            <tr className="border-b-1 border-zinc-700">
              <td className="text-[#C1C1C1] p-3">Frontend:</td>
              <td className="font-medium p-3">
                {fe_rank ? fe_rank.rank : '-'}
              </td>
            </tr>
            <tr>
              <td className="text-[#C1C1C1] p-3">Backend:</td>
              <td className="font-medium p-3">-</td>
            </tr>
          </table>
        </div>
      </CardWrapper>
    </div>
  )
}

// const BestRank = ({
//   dashboardDetails
// }: {
//   dashboardDetails: DashboardDetails
// }) => {
//   const bestData = useMemo(() => {
//     if (
//       !dashboardDetails.fe_leaderboard_details.rank &&
//       !dashboardDetails.leaderboard_details.rank
//     )
//       return { name: '', rank: '-' }

//     if (!dashboardDetails.leaderboard_details.rank)
//       return {
//         name: 'FE Challenge',
//         rank: dashboardDetails.fe_leaderboard_details.rank
//       }

//     if (!dashboardDetails.fe_leaderboard_details.rank)
//       return {
//         name: 'DSA Challenge',
//         rank: dashboardDetails.leaderboard_details.rank
//       }

//     if (
//       dashboardDetails.leaderboard_details.rank >
//       dashboardDetails.fe_leaderboard_details.rank
//     ) {
//       return {
//         name: 'DSA Challenge',
//         rank: dashboardDetails.leaderboard_details.rank
//       }
//     }

//     return {
//       name: 'FE Challenge',
//       rank: dashboardDetails.fe_leaderboard_details.rank
//     }
//   }, [dashboardDetails])
//   return (
//     <div className="flex flex-col h-full w-full">
//       <div className="flex justify-between">
//         <div style={{ visibility: 'hidden' }} className="mb-2">
//           Best Rank
//         </div>
//       </div>
//       <CardWrapper>
//         <div className="flex flex-col p-4 justify-center items-center h-full w-full">
//           <div className="text-base">Best Rank</div>
//           <div className="flex">
//             <TrophyIcon className="h-32 w-28" />
//           </div>

//           <div className="text-base font-semibold">#{bestData.rank}</div>

//           <div className="text-sm text-[#C1C1C1]">{bestData.name}</div>
//         </div>
//       </CardWrapper>
//     </div>
//   )
// }
